var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M850.43,461.26c0-2.4-.85-3.3-4.61-3.3v-1.7H862c9.5,0,12.6,4.4,12.6,8.5,0,4.4-4.5,7.55-9.8,7.55v.1c7.4.25,11.5,3.55,11.5,8.85,0,3.2-2.95,9.4-11.4,9.4H845.82V489c3.76,0,4.61-.9,4.61-3.3Zm10.05,10.5c6.7,0,8.3-2.7,8.3-6.6,0-5.2-2.6-7.2-8.7-7.2-4.1,0-4.55,1.1-4.55,2.5v11.3Zm-5,1.7v12.05c0,2.6,1,3.45,5.15,3.45,7.6,0,9.8-2.75,9.8-7.7,0-4.7-2.1-7.8-7-7.8Z",
    transform: "translate(-845.82 -456.26)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M885.38,478.76c0,6.9,3,10.8,7.25,10.8,3.35,0,5.6-2.05,7.5-4.6l1.2.8c-2.25,3.3-5,5.5-10.35,5.5-6.2,0-11-5.7-11-12.35s4.81-12.35,11-12.35c5.85,0,10.6,4.1,10.6,12.2Zm11.1-1.7c0-3.6-.7-8.8-5.6-8.8s-5.5,5.2-5.5,8.8Z",
    transform: "translate(-845.82 -456.26)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M910,478.76c0,6.9,3,10.8,7.25,10.8,3.35,0,5.6-2.05,7.5-4.6l1.2.8c-2.25,3.3-5,5.5-10.35,5.5-6.2,0-11-5.7-11-12.35s4.8-12.35,11-12.35c5.85,0,10.6,4.1,10.6,12.2Zm11.1-1.7c0-3.6-.7-8.8-5.6-8.8s-5.5,5.2-5.5,8.8Z",
    transform: "translate(-845.82 -456.26)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M941.33,490.66h-13.2V489c2.89,0,3.8-.5,3.8-2.1V471c0-1.6-.91-2.1-3.61-2.1v-1.7l8-.3v6.8h.1c1-4,2.7-7.1,6.85-7.1a3.62,3.62,0,0,1,3.95,3.45,2.67,2.67,0,0,1-2.65,2.65,2.21,2.21,0,0,1-2.45-2.35,2.24,2.24,0,0,1,1-1.95,2.22,2.22,0,0,0-.65-.1c-3.35,0-5.85,6.15-5.85,15.65,0,4.15.3,5,4.7,5Z",
    transform: "translate(-845.82 -456.26)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeer);
export default __webpack_public_path__ + "static/media/Beer.e77bfd92.svg";
export { ForwardRef as ReactComponent };